import { useSetAtom } from "jotai";
import { useCallback } from "react";

import { loadingAtom } from "@/states/loading/atoms";
import { TaskId } from "@/states/loading/types";

export const useLoading = () => {
  const setLoading = useSetAtom(loadingAtom);

  return useCallback(
    async <T>(callback: () => Promise<T>, customText?: string) => {
      // start
      const newTask = { id: generateTaskId(), customText };
      setLoading((prev) => ({
        customText,
        tasks: [...prev.tasks, newTask],
      }));

      return await callback().finally(() => {
        // end
        setLoading((prev) => {
          const processingTasks = prev.tasks.filter(
            (task) => task.id !== newTask.id,
          );
          return { tasks: processingTasks };
        });
      });
    },
    [setLoading],
  );
};

function generateTaskId(): TaskId {
  return new Date().getTime().toString();
}
